import './App.css';
import Board from './components/Board.js';

function App() {
  return (
    <div>
      <Board />
    </div>
  );
}

export default App;
